const EditStatusIcon = () => {
  return (
    <svg data-testid="tpEditStatus"  width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="6" fill="#EFA00B" />
    </svg>
  );
};

export default EditStatusIcon;
